import { canv } from "@/canv/global";
import { OFFSET, PADDING_SUBMENU, WIDGET_MENU_PADDING } from "@/interface/ContextMenu/const";
import type { Position } from "@/interface/ContextMenu/types";

export const getContextMenuPosition = (menu: HTMLElement): Position => {
    const menuRect = menu.getBoundingClientRect();
    const canvasRect = canv.canvas.getBoundingClientRect();

    let x = canv.actionManager.lastX ?? 0;
    let y = canv.actionManager.lastY ?? 0;

    if (x < OFFSET) x = OFFSET;
    if (y < OFFSET) y = OFFSET;

    if (x + menuRect.width + OFFSET > canvasRect.width) {
        x = canvasRect.width - menuRect.width - OFFSET;
    }

    if (y + menuRect.height + OFFSET > canvasRect.height) {
        y = canvasRect.height - menuRect.height - OFFSET;
    }

    return { x, y };
};

export const getSubmenuPosition = (submenu: HTMLElement, alignBy: HTMLElement): Position => {
    const submenuRect = submenu.getBoundingClientRect();
    const alignByRect = alignBy.getBoundingClientRect();
    const canvasRect = canv.canvas.getBoundingClientRect();

    let x = alignByRect.right + OFFSET + PADDING_SUBMENU;
    if (x + submenuRect.width + OFFSET + PADDING_SUBMENU > canvasRect.width) {
        x = alignByRect.left - submenuRect.width - OFFSET - PADDING_SUBMENU;
    }
    if (x < OFFSET) x = OFFSET;

    let y = alignByRect.top;
    if (y < OFFSET) y = OFFSET;
    if (y + submenuRect.height + OFFSET > canvasRect.height) {
        y = canvasRect.height - submenuRect.height - OFFSET;
    }

    return { x, y };
};

export function getContextMenuSelectedPosition(menu: HTMLDivElement, button: HTMLButtonElement) {
    const menuRect = menu.getBoundingClientRect();
    const buttonRect = button.getBoundingClientRect();
    const canvasRect = canv.canvas.getBoundingClientRect();

    let x = buttonRect.right - menuRect.width + WIDGET_MENU_PADDING;
    let y = buttonRect.bottom + OFFSET;

    if (x + menuRect.width + OFFSET > canvasRect.width) {
        x = canvasRect.width - menuRect.width - OFFSET;
    }

    if (y + menuRect.height + OFFSET > canvasRect.height) {
        y = canvasRect.height - menuRect.height - OFFSET;
    }

    return { x, y };
}
